import { MODALS } from 'common/domain/constants';

class LoansSignUpModalController {

  constructor() {}

  get modal() {
    return $(MODALS.SIGN_UP);
  }

  requestIsFailed() {
    return this.error === true;
  }

  closeModal() {
    this.modal.modal('hide');
  }

  onDismiss() {
    this.closeModal();
  }

}

export default LoansSignUpModalController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpModal/loansSignUpModal.controller.js